export const LotMetrics = {
    SALEYARD: [
        { key: 'stockType' },
        { key: 'breed' },
        { key: 'age' },
        { key: 'tbStatus' },
        { key: 'withholding' },
        { key: 'agency' },
        { key: 'vendorName' },
        { key: 'description' },
    ],
    SEQ: [{ key: 'stockType' }, { key: 'aveWeight' }, { key: 'location' }, { key: 'withholding' }, { key: 'agent' }],
    HYBRID: [{ key: 'stockType' }, { key: 'aveWeight' }, { key: 'location' }, { key: 'withholding' }, { key: 'agent' }],
}
